import TextEditor from '../../components/textEditor/TextEditor'

const RefundPolicy = () => {
    return (
        <TextEditor tag_name="refund_policy" />
    )
}

export default RefundPolicy